import _ from "underscore";
import EmptyMessageBuilder from "./EmptyMessageBuilder";
import messageResource from "../../../messageResource";

export default function UserSelectorEmptyMessageBuilder(userSelectorGroupsStrategy)
{
    EmptyMessageBuilder.call(this);
    this.userSelectorGroupsStrategy = userSelectorGroupsStrategy;
}

UserSelectorEmptyMessageBuilder.prototype = _.create(EmptyMessageBuilder.prototype, {
    createMessages: function()
    {
        this.messages["noNodesMatchingSearch"] = this.userSelectorGroupsStrategy.getNoNodesMatchingSearchMessage();
        this.messages["noSelectedNodes"] = this.userSelectorGroupsStrategy.getNoSelectedNodesMessage();
        this.messages["noSelectedNodesHasDisabled"] = messageResource.getMessage("users_selector.hide_not_selected.only_disabled");
        this.messages["emptyTree"] = messageResource.getMessage("users_selector.no_users_assigned");
    }
});


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/emptyMessagesBuilders/UserSelectorEmptyMessageBuilder.js